// extracted by mini-css-extract-plugin
var _1 = "PersonComponentStyle-module__buttons___CenyQ";
var _2 = "PersonComponentStyle-module__edit___Hzw1y";
var _3 = "PersonComponentStyle-module__fa___AuWwm";
var _4 = "PersonComponentStyle-module__name-holder___X1Yqv";
var _5 = "PersonComponentStyle-module__name-holder___X1Yqv";
var _6 = "PersonComponentStyle-module__person___QjBBT";
var _7 = "PersonComponentStyle-module__person--edit___IvXtw";
var _8 = "PersonComponentStyle-module__person-avatar___hF5Ml";
var _9 = "PersonComponentStyle-module__person-description___prhLF";
var _a = "PersonComponentStyle-module__person-description--edit___drtED";
var _b = "PersonComponentStyle-module__person-for-editable___jDawm";
var _c = "PersonComponentStyle-module__person-image___yk7zF";
var _d = "PersonComponentStyle-module__person-name___TyGaq";
var _e = "PersonComponentStyle-module__person-position___M3QEt";
var _f = "PersonComponentStyle-module__person-social___Gz5T7";
var _10 = "PersonComponentStyle-module__person-social-empty___SVvjg";
var _11 = "PersonComponentStyle-module__person-avatar___hF5Ml";
var _12 = "PersonComponentStyle-module__person-description___prhLF";
var _13 = "PersonComponentStyle-module__person-description--edit___drtED";
var _14 = "PersonComponentStyle-module__person--edit___IvXtw";
var _15 = "PersonComponentStyle-module__person-for-editable___jDawm";
var _16 = "PersonComponentStyle-module__person-image___yk7zF";
var _17 = "PersonComponentStyle-module__person-name___TyGaq";
var _18 = "PersonComponentStyle-module__person-position___M3QEt";
var _19 = "PersonComponentStyle-module__person-social___Gz5T7";
var _1a = "PersonComponentStyle-module__person-social-empty___SVvjg";
export { _1 as "buttons", _2 as "edit", _3 as "fa", _4 as "name-holder", _5 as "nameHolder", _6 as "person", _7 as "person--edit", _8 as "person-avatar", _9 as "person-description", _a as "person-description--edit", _b as "person-for-editable", _c as "person-image", _d as "person-name", _e as "person-position", _f as "person-social", _10 as "person-social-empty", _11 as "personAvatar", _12 as "personDescription", _13 as "personDescriptionEdit", _14 as "personEdit", _15 as "personForEditable", _16 as "personImage", _17 as "personName", _18 as "personPosition", _19 as "personSocial", _1a as "personSocialEmpty" }
